import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';

export interface ImageLoaderProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: React.ReactNode;
}

/**
 * Loads an image from the given URL.
 * If it doesn't exist, display either nothing or a fallback
 */

export const ImageWithFallback: React.FC<ImageLoaderProps> = ({
  src,
  onError,
  onLoad,
  fallback,
  alt, // Required to suppress eslint warning
  ...props
}) => {
  const [state, setState] = React.useState<'loading' | 'loaded' | 'error'>('loading');

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setState('error');
    onError?.(e);
  };

  const handleLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setState('loaded');
    onLoad?.(e);
  };
  useEffect(() => {
    setState('loading');
  }, [src]);

  if (state === 'error' || !src) {
    return <>{fallback}</>;
  }

  return (
    <>
      {state === 'loading' && <Spinner size="sm" animation="border" />}
      <img src={src} onError={handleError} onLoad={handleLoad} alt={alt} {...props} />
    </>
  );
};
